import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contract";

export function LoadFreespinCommand(): Contract<void> {
    const payload = new FreespinRequestPayload();

    return CommsManager.request(payload);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/comms/load-freespin-command.ts